import NotionAccessibility from '@/autoGeneratedPages/NotionAccessibility';
import NotionAnimation from '@/autoGeneratedPages/NotionAnimation';
import NotionBranding from '@/autoGeneratedPages/NotionBranding';
import NotionBrandingStyle from '@/autoGeneratedPages/NotionBranding/subpages/NotionStyle';
import NotionComponents from '@/autoGeneratedPages/NotionComponents';
import NotionContacts from '@/autoGeneratedPages/NotionContacts';
import NotionDesignTokens from '@/autoGeneratedPages/NotionDesignTokens';
import NotionFigma from '@/autoGeneratedPages/NotionFigma';
import NotionFigmaDesignreview from '@/autoGeneratedPages/NotionFigma/subpages/NotionDesignreview';
import NotionFigmaStart from '@/autoGeneratedPages/NotionFigma/subpages/NotionStart';
import NotionFigmaTeamAndProjects from '@/autoGeneratedPages/NotionFigma/subpages/NotionTeamAndProjects';
import NotionFigmaTools from '@/autoGeneratedPages/NotionFigma/subpages/NotionTools';
import NotionFigmaWork from '@/autoGeneratedPages/NotionFigma/subpages/NotionWork';
import NotionGrid from '@/autoGeneratedPages/NotionGrid';
import NotionGridVisualEffects from '@/autoGeneratedPages/NotionGrid/subpages/NotionVisualEffects';
import NotionIconStyle from '@/autoGeneratedPages/NotionIconStyle';
import NotionManyThanks from '@/autoGeneratedPages/NotionManyThanks';
import NotionPalette from '@/autoGeneratedPages/NotionPalette';
import NotionTypography from '@/autoGeneratedPages/NotionTypography';
import NotionVoiceAndTone from '@/autoGeneratedPages/NotionVoiceAndTone';
import NotionVoiceAndToneClean from '@/autoGeneratedPages/NotionVoiceAndTone/subpages/NotionClean';
import NotionVoiceAndToneCompetent from '@/autoGeneratedPages/NotionVoiceAndTone/subpages/NotionCompetent';
import NotionVoiceAndToneEasy from '@/autoGeneratedPages/NotionVoiceAndTone/subpages/NotionEasy';
import NotionVoiceAndToneGlossary from '@/autoGeneratedPages/NotionVoiceAndTone/subpages/NotionGlossary';
import NotionVoiceAndToneHuman from '@/autoGeneratedPages/NotionVoiceAndTone/subpages/NotionHuman';
import NotionVoiceAndToneInterface from '@/autoGeneratedPages/NotionVoiceAndTone/subpages/NotionInterface';

export const getPrefix = () => process.env.PUBLIC_URL === '/paradigm.mail.ru' ? '/paradigm.mail.ru' : '';

let prefix = getPrefix();

const VOICE_AND_TONE = '/voice_and_tone';
const COMPONENTS = '/components';
const PALETTE = '/palette';
const TYPOGRAPHY = '/typography';
const ICON_STYLE = '/icon_style';
const BRANDING = '/branding';
const GRID = '/grid';
const FIGMA = '/figma';
const COMMUNICATIONS = '/communications';
const DESIGN_TOKENS = '/design_tokens';
const MANY_THANKS = '/many_thanks';
const ACCESSIBILITY = '/accessibility';
const ANIMATION = '/animation';
const WHATS_NEW = '/whats_new';

const notPreparedUrls = {
    branding: BRANDING,
    style: BRANDING + '/style',
    logos: BRANDING + '/logos',
    palette: PALETTE,
    typography: TYPOGRAPHY,
    icon_style: ICON_STYLE,
    icons: ICON_STYLE + '/icons',
    grid: GRID,
    visual_effects: GRID + '/visual_effects',
    animation: ANIMATION,
    token_paddings: DESIGN_TOKENS + '/paddings',
    token_states: DESIGN_TOKENS + '/states',
    token_colors: DESIGN_TOKENS + '/colors',
    token_borders_shadows: DESIGN_TOKENS + '/borders_shadows',
    token_images: DESIGN_TOKENS + '/images',
    token_typography: DESIGN_TOKENS + '/typography',
    illustrations: '/illustrations',
    communications: COMMUNICATIONS,
    emailsTechnical: COMMUNICATIONS + '/emails_technical',
    emailsPromo: COMMUNICATIONS + '/emails_promo',
    components: COMPONENTS,
    design_tokens: DESIGN_TOKENS,
    button: COMPONENTS + '/button',
    input: COMPONENTS + '/input',
    checkbox: COMPONENTS + '/checkbox',
    radio: COMPONENTS + '/radio',
    select: COMPONENTS + '/select',
    tabs: COMPONENTS + '/tabs',
    paging: COMPONENTS + '/paging',
    segmented: COMPONENTS + '/segmented',
    avatar: COMPONENTS + '/avatar',
    loaders: COMPONENTS + '/loaders',
    pulsar: COMPONENTS + '/pulsar',
    voice_and_tone: VOICE_AND_TONE,
    text_principles: VOICE_AND_TONE + '/text_principles',
    text_sentence: VOICE_AND_TONE + '/text_sentence',
    text_word: VOICE_AND_TONE + '/text_word',
    text_sign: VOICE_AND_TONE + '/text_sign',
    text_decoration: VOICE_AND_TONE + '/text_decoration',
    text_glossary: VOICE_AND_TONE + '/text_glossary',
    figma: FIGMA,
    figma_start: FIGMA + '/start',
    figma_team_and_projects: FIGMA + '/team_and_projects',
    figma_tools: FIGMA + '/tools',
    figma_work: FIGMA + '/work',
    figma_for_developer: FIGMA + '/for_developer',
    figma_for_manager: FIGMA + '/for_manager',
    accessibility: ACCESSIBILITY,
    contacts: '/сontacts',
    many_thanks: MANY_THANKS,
    whats_new: WHATS_NEW,
};

const notPreparedImgUrls = {
    avatar: '/img/avatar.jpg',
    logo: '/img/paradigm_logo_large.svg',
    logoBackground: '/img/main_page_decoration.svg',
    logoSmall: "/img/paradigm_logo_small.svg",
    interfaceGrid: '/img/interface_grid.png',
    structuralGrid: '/img/structural_grid.png',
    layoutBlocks: '/img/layout_blocks.png',
    layoutBlocksContainers: '/img/layout_blocks_containers.png',
    pageNotFound: '/img/page_not_found.svg',
};

const urls = {};
for (let key in notPreparedUrls) {
    urls[key] = prefix + notPreparedUrls[key];
}

const urlsImg = {};
for (let key in notPreparedImgUrls) {
    urlsImg[key] = prefix + notPreparedImgUrls[key];
}

const mainUrl = prefix + '/';
const paradigmUrl = prefix + '/paradigm';

// тут наши автосгенерированные страницы таской update-paradigm
// Этот массив страниц был автоматически сгенерирован. Не редактируйте его вручную.
const autoPages = [
{
    name: 'Бренд',
    url: '/branding',
    component: NotionBranding,
    childrens: [
{
    name: 'Основа визуального языка',
    url: '/branding/style',
    component: NotionBrandingStyle
  }
    ]
  },
{
    name: 'Палитра',
    url: '/palette',
    component: NotionPalette
  },
{
    name: 'Типографика',
    url: '/typography',
    component: NotionTypography
  },
{
    name: 'Иконографика',
    url: '/icon_style',
    component: NotionIconStyle
  },
{
    name: 'Структура и сетка',
    url: '/grid',
    component: NotionGrid,
    childrens: [
{
    name: 'Эффекты',
    url: '/grid/visual_effects',
    component: NotionGridVisualEffects
  }
    ]
  },
{
    name: 'Анимации',
    url: '/animation',
    component: NotionAnimation
  },
{
    name: 'Редполитика',
    url: '/voice_and_tone',
    component: NotionVoiceAndTone,
    childrens: [
{
    name: 'Пишем чисто',
    url: '/voice_and_tone/clean',
    component: NotionVoiceAndToneClean
  },
{
    name: 'Пишем просто',
    url: '/voice_and_tone/easy',
    component: NotionVoiceAndToneEasy
  },
{
    name: 'Пишем компетентно',
    url: '/voice_and_tone/competent',
    component: NotionVoiceAndToneCompetent
  },
{
    name: 'Пишем для человека',
    url: '/voice_and_tone/human',
    component: NotionVoiceAndToneHuman
  },
{
    name: 'Интерфейсные тексты',
    url: '/voice_and_tone/interface',
    component: NotionVoiceAndToneInterface
  },
{
    name: 'Глоссарий',
    url: '/voice_and_tone/glossary',
    component: NotionVoiceAndToneGlossary
  }
    ]
  },
{
    name: 'Компоненты',
    url: '/components',
    component: NotionComponents
  },
{
    name: 'Дизайн-токены',
    url: '/design_tokens',
    component: NotionDesignTokens
  },
{
    name: 'Работа в Figma',
    url: '/figma',
    component: NotionFigma,
    childrens: [
{
    name: 'Начало работы',
    url: '/figma/start',
    component: NotionFigmaStart
  },
{
    name: 'Команды и проекты',
    url: '/figma/team_and_projects',
    component: NotionFigmaTeamAndProjects
  },
{
    name: 'Инструменты',
    url: '/figma/tools',
    component: NotionFigmaTools
  },
{
    name: 'Работа',
    url: '/figma/work',
    component: NotionFigmaWork
  },
{
    name: 'Дизайн–ревью',
    url: '/figma/designreview',
    component: NotionFigmaDesignreview
  }
    ]
  },
{
    name: 'Доступность',
    url: '/accessibility',
    component: NotionAccessibility
  },
{
    name: 'Контакты',
    url: '/contacts',
    component: NotionContacts
  },
{
    name: 'Благодарности',
    url: '/many_thanks',
    component: NotionManyThanks
  }
];

// сюда при необходимости отправляем кастомные компоненты
const constantPages = [];

const extendedPages = [
    ...autoPages,
    ...constantPages
];

export { urls, mainUrl, constantPages, urlsImg, paradigmUrl, prefix, extendedPages };
export default extendedPages;
